import { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getFulfillmentCenterSelected } from 'src/services/fulfillmentCenter/fulfillmentCenterService'

const getFcSelected = () => {
  const fc = getFulfillmentCenterSelected()
  if (!fc) {
    return
  }
  return fc
}

const validateFc = (fc, history) => {
  return () => {
    if (!fc) {
      toast.error('FC não configurado! Faça login novamente!')
      history.push('/')
      setTimeout(() => {
        window.location.reload()
      }, 3000)
    }
  }
}

export const useFulfillmentCenter = () => {
  const fc = useMemo(() => getFcSelected(), [])
  const history = useHistory()

  return {
    validateFc: validateFc(fc, history),
    fc
  }
}
